import { withNamespace } from "@/i18n/lazy-route"

/** Plans and overage (LLD §9.10, Tasks 5.1, 5.2), with the `plans` namespace. */
export const PlansScreen = withNamespace("plans", () => import("./screens/PlansScreen"), {
  en: () => import("@/i18n/locales/en/plans.json"),
  fr: () => import("@/i18n/locales/fr/plans.json"),
})
